/**
 * @generated SignedSource<<1b278a07f7fa12050a6e9ee8dfa8193d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailLayoutsViewEmailLayoutsQuery$variables = Record<PropertyKey, never>;
export type EmailLayoutsViewEmailLayoutsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EmailLayoutList_query">;
};
export type EmailLayoutsViewEmailLayoutsQuery = {
  response: EmailLayoutsViewEmailLayoutsQuery$data;
  variables: EmailLayoutsViewEmailLayoutsQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailLayoutsViewEmailLayoutsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EmailLayoutList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmailLayoutsViewEmailLayoutsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EmailLayout",
        "kind": "LinkedField",
        "name": "emailLayouts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emailLayoutIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "203e7ca0c04a4228a56591902a288f14",
    "id": null,
    "metadata": {},
    "name": "EmailLayoutsViewEmailLayoutsQuery",
    "operationKind": "query",
    "text": "query EmailLayoutsViewEmailLayoutsQuery {\n  ...EmailLayoutList_query\n}\n\nfragment EmailLayoutList_query on Query {\n  emailLayouts {\n    id\n    emailLayoutIdentifier\n    name\n    isDefault\n    createdAt\n    updatedAt\n  }\n}\n"
  }
};

(node as any).hash = "8521672cd03e029700e91a889e9a565e";

export default node;
